import { Box, BoxProps, Heading, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { Fragment } from 'react';

type Option<OptionType> = { label: string | JSX.Element; value: OptionType };

type Props<OptionType> = Omit<BoxProps, 'onChange'> & {
  title?: string;
  onChange(nextValue: OptionType): void;
  value?: OptionType;
  options: Option<OptionType>[];
  isDisabled?: boolean;
};

export const FilterDrawerRadioGroup = <OptionType extends string>({
  title,
  onChange,
  value,
  options,
  isDisabled = false,
  ...boxProps
}: Props<OptionType>) => (
  <Box {...boxProps}>
    {!!title && (
      <Heading fontSize="xl" fontWeight="300" mb="space.12">
        {title}
      </Heading>
    )}
    <RadioGroup
      onChange={onChange}
      value={value}
      border="1px solid"
      borderColor="gray.2"
      borderRadius="radius.12"
      py="space.16"
    >
      <Stack direction="column" spacing="space.16">
        {options.map((item, index, self) => (
          <Fragment key={item.value}>
            <Radio
              size="lg"
              value={item.value}
              px="space.16"
              borderWidth="4px"
              boxShadow="0 0 0 1px"
              color="gray.2"
              borderColor="white"
              background="white"
              _checked={{
                bg: 'black',
                borderColor: 'white',
              }}
              _focusVisible={{ boxShadow: 'outline' }}
              isDisabled={isDisabled}
            >
              {item.label}
            </Radio>
            {index + 1 !== self.length && (
              <Box width="100%" height="1px" display="block" bg="gray.2" />
            )}
          </Fragment>
        ))}
      </Stack>
    </RadioGroup>
  </Box>
);
